import { Pipe, PipeTransform } from '@angular/core';
import { LoginService } from '../../../services/login/login.service';

@Pipe({
  name: 'getDatosUsuario'
})
export class GetDatosUsuarioPipe implements PipeTransform {

  constructor(private loginService: LoginService) { }

  transform(value: any, args: any): any {
    const data: any = this.loginService.getDataClientePedido();
    switch (value) {
      case 'client_number':
        return data.client_number;
      case 'company_name':
        return data.company_name;
      case 'tipoCambio':
        return data.tipoCambio;
      default:
        return '';
    }
  }
}
